import React, {FC, memo, useMemo, useState} from 'react'
import {Form as FormikForm, Formik} from 'formik'
import {Accordion} from 'react-bootstrap'
import SignAccordionSkeleton from './src/SignAccordionSkeleton'
import SignAccordionItem from './src/SignAccordionItem'
import useListData from '../../../api/hooks/useListData'
import {Pagination} from '../ModuleList/src/Pagination'
import ComponentCheckbox from '../../components/ComponentCheckbox'
import ComponentButton from '../../components/ComponentButton'
import {TModuleSignAccordion, TSignRow} from './_types'

const ModuleSignAccordion: FC<TModuleSignAccordion> = memo(({settings}) => {
    const {
        object,
        property_title,
        property_body,
        property_status,
        property_signed_at,
        redirect_page,
        filters,
        select,
    } = settings

    const initialFilters = useMemo(
        () => ({
            ...(filters ?? {}),
        }),
        []
    )

    const [filter, setFilter] = useState({page: 1, limit: 20})
    const {data, isLoading} = useListData(object, {...filter, ...initialFilters})

    const handleMassSign = async (values: {selectedItems: TSignRow[]}) => {
        console.log('Selected for sign:', values.selectedItems)
    }

    const rawRows: any[] = data?.data ?? []
    const rows: TSignRow[] = rawRows.filter((r) => typeof r.id === 'number')

    return (
        <div className='moduleSignAccordion'>
            {isLoading ? <SignAccordionSkeleton /> : null}

            <Formik<{
                selectedItems: TSignRow[]
                data: TSignRow[]
            }>
                enableReinitialize
                initialValues={{
                    selectedItems: [],
                    data: rows,
                }}
                onSubmit={handleMassSign}
            >
                {({values, setFieldValue}) => {
                    const selected = values.selectedItems

                    const allChecked =
                        rows.length > 0 &&
                        rows.every((row) => selected.some((s) => s.id === row.id))

                    const toggleMass = () => {
                        const newList = allChecked ? [] : rows
                        setFieldValue('selectedItems', newList)
                    }

                    const toggleItem = (row: TSignRow) => {
                        const exists = selected.some((x) => x.id === row.id)
                        if (exists) {
                            setFieldValue(
                                'selectedItems',
                                selected.filter((x) => x.id !== row.id)
                            )
                        } else {
                            setFieldValue('selectedItems', [...selected, row])
                        }
                    }

                    return (
                        <FormikForm>
                            {rows.length > 0 && (
                                <div className='moduleSignAccordion_massSelector'>
                                    <ComponentCheckbox
                                        customChecked={allChecked}
                                        customHandler={toggleMass}
                                        label='Выбрать все'
                                    />

                                    {selected.length > 0 && (
                                        <ComponentButton
                                            type='submit'
                                            settings={{
                                                title: `Подписать выбранные (${selected.length})`,
                                                background: 'dark',
                                                icon: 'check',
                                            }}
                                        />
                                    )}
                                </div>
                            )}

                            <Accordion>
                                {rows.map((doc) => {
                                    const checked = selected.some((s) => s.id === doc.id)

                                    return (
                                        <SignAccordionItem
                                            key={doc.id}
                                            id={doc.id}
                                            title={doc.title}
                                            body={doc.body}
                                            status={doc.sign_status}
                                            signedAt={doc.signed_at}
                                            redirect_page={redirect_page}
                                            checked={checked}
                                            onToggle={() => toggleItem(doc)}
                                            href={doc.href}
                                        />
                                    )
                                })}
                            </Accordion>

                            <Pagination
                                detail={data?.detail}
                                filter={filter}
                                setFilter={setFilter}
                            />
                        </FormikForm>
                    )
                }}
            </Formik>
        </div>
    )
})

export default ModuleSignAccordion
